// Angular-Module
import {Injectable} from '@angular/core';
// ReactiveX for JavaScript
import {Observable} from 'rxjs';
// Globale Services
import {BackendService} from '@global/services/backend.service';
// Interfaces für Structured Objects einbinden
import {CWResult} from '@shared/cw-result';

@Injectable({providedIn: 'root'})
export class EventsBudgetAssignmentService {
    /**
     * Konstruktor
     * @param backendService
     */
    constructor(private backendService: BackendService) {}

    /**
     * Fragt vom Backend die verfügbaren Budget-IDs einer Region in einem gegebenen Geschäftsjahr an
     * @param regionId number
     * @param budgetYear number
     * @returns Observable<CWResult> Ein Observable, welches an den Backend-Request gebunden ist.
     * @author Lennart Bentz <l.bentz@pharmakon.software>
     */
    getRegionBudgetsForBudgetYear(regionId: number, budgetYear: number): Observable<CWResult> {
        return <Observable<CWResult>>(
            this.backendService.getRequest(
                'EventsBudgetAssignment/getBudgetYearRegionBudgets/' + budgetYear + '/' + regionId,
            )
        );
    }

    saveEventBudgetAssignments(formData) {
        return <Observable<CWResult>> this.backendService.postRequest('EventsBudgetAssignment/edit/', formData);
    }

    loadEventBudgetAssignments(eventId: number): Observable<CWResult> {
        return <Observable<CWResult>>(
            this.backendService.getRequest('EventsBudgetAssignment/details/' + eventId + '/')
        );
    }
}
